export default "__VITE_ASSET__DZP3oB3s__"